import { queryClient } from "@/services/react-query";

/**
 * Refetch inscription + aggregated progress queries so modals (e.g. inscrição finalizada)
 * and headers update without navigating away from the challenge/course flow.
 */
export async function invalidateRegistrationProgressQueries(): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: ["reality-info"],
      exact: false,
    }),
    queryClient.invalidateQueries({
      queryKey: ["inscription-status"],
      exact: false,
    }),
    queryClient.invalidateQueries({
      queryKey: ["completed-challenges"],
      exact: false,
    }),
    queryClient.invalidateQueries({
      queryKey: ["completed-courses"],
      exact: false,
    }),
    queryClient.invalidateQueries({
      queryKey: ["get-courses"],
      exact: false,
    }),
    queryClient.invalidateQueries(["get-courses-pdc"], { exact: false }),
  ]);
}
